<template>
  <xn-modal v-bind="attrs" :width="width" uid="tip" class="tip-modal">
    <template #title>
      <div class="tip-title">
        <xn-icon :icon="`alert_${theme}`" class="icon" />
        <span class="s2-ml">{{ title }}</span>
      </div>
    </template>
    <div class="tip-content"> <div class="text" v-html="content" /> </div>
    <div class="xn-footer">
      <a-button :loading="loading" :type="okType" :danger="okDanger" @click="submit" >
        {{ submitText }}
      </a-button>
      <a-button :loading="loading" @click="toCancel">{{ cancelText }}</a-button>
    </div>
  </xn-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useStore } from 'vuex'


const store = useStore()
// 自定义样式title全部使用slot
const title = computed(() => (store.state.modal.data?.tip?.modal?.title || '提示'))
const width = computed(() => (+store.state.modal.data?.tip?.modal?.width || 420))
const content = computed(() => (store.state.modal.data?.tip?.modal?.content || ''))
const theme = computed(() => (store.state.modal.data?.tip?.modal?.theme || 'warning'))
const okType = computed<any>(() => (store.state.modal.data?.tip?.modal?.submitType || 'primary'))
const okDanger = computed<any>(() => (store.state.modal.data?.tip?.modal?.okDanger || false))
const submitText = computed<any>(() => (store.state.modal.data?.tip?.modal?.submitText || '确认'))
const cancelText = computed<any>(() => (store.state.modal.data?.tip?.modal?.cancelText || '取消'))

const attrs = computed(() => {
  const { data } = store.state.modal
  if (data?.tip?.modal) {
    const { title, ...rest } = data.tip.modal
    return rest
  }
  return {}
})

const loading = ref(false)
const submit = () => {
  loading.value = true
  const api = store.state.modal.data?.tip?.modal?.api
  if (api) api(close)
  else close()
}

const toCancel = () => {
  const api = store.state.modal.data?.tip?.modal?.cancelApi
  if (api) api(close)
  else close()
}

const close = () => {
  store.commit('modal/close', { uid: 'tip' })
  loading.value = false
}
</script>

<style lang="scss" scoped>
.text {
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.88);
}
.icon {
  width: 20px;
  height: 20px;
}
.tip-title {
  display: flex;
  align-items: center;
}
.tip-content {
  margin-left: 28px;
}
</style>
